<script setup lang="ts">
import HistoryInfo from './HistoryInfo.vue'
</script>

<template>
  <HistoryInfo
    title="No incidents match the selected filters"
    icon="filter"
    description="Try to change the filters or clear them to see all incidents"
  />
</template>
